import React from 'react';
import PropTypes from 'prop-types';

/**
 * Skeleton de carga para un widget.
 * Se muestra mientras se obtienen los datos.
 */
const WidgetSkeleton = ({ className = '' }) => {
  return (
    <div className={['h-full w-full animate-pulse rounded-2xl bg-surface-elevated', className].filter(Boolean).join(' ')} />
  );
};

WidgetSkeleton.propTypes = {
  className: PropTypes.string,
};


export default WidgetSkeleton;
